
/** Where an invoice or bill stands with its accounting system (AccountingResult.status). */
export enum AccountingStatus {
    // Queued for the accounting sync worker
    Pending = 'Pending',
    // Claimed by a worker that is pushing it now
    Processing = 'Processing',
    // Confirmed by the accounting system
    Processed = 'Processed',
    Error = 'Error',
    // A $0 document the accounting system is never sent; nothing to act on
    Skipped = 'Skipped'
}

export enum AccountingSystem {
    Xero = 'Xero',
    MYOB = 'Myob',
    QuickBooks = 'QuickBooks',
    Manual = 'Manual',
    Jobpac = 'Viewpoint Jobpac Connect',
    MYOBAcumatica = 'MYOB Acumatica',
    // Matches ServiceConnectionType.BGISManhattanONE: a company's mapping.type is copied from the connection it is linked through
    ManhattanOne = 'BGISManhattanONE'
}

export enum TaxType {
    GSTOnImport = 'GSTONIMPORTS',
    TaxOnPurchase = 'INPUT',
    TaxExempt = 'NONE',
    TaxOnSale = 'OUTPUT'
}

export enum TrackingCategory {
    JobType = 'Job Type',
    Customer = 'Customer',
    JobPriority = 'Job Priority',
    StageCategory = 'Stage Category',
    ItemCategory = 'Item Category',
    ItemSubCategory = 'Item Subcategory',
    CatalogueTracking1 = 'Item Tracking Category 1',
    CatalogueTracking2 = 'Item Tracking Category 2'
}

export enum MappingTrackingCategory {
    TrackingCategory1 = 'trackingCategory1',
    TrackingCategory2 = 'trackingCategory2'
}

